import { Injectable } from '@angular/core';
import { fromEvent, BehaviorSubject, fromEventPattern } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MobileDetectionService {
  private deviceTypeSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  private orientationSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");

  public constructor() {
    this.detectDeviceType();
    this.detectOrientation();
  }

  get deviceType$() {
    return this.deviceTypeSubject.asObservable();
  }

  get orientation$() {
    return this.orientationSubject.asObservable();
  }

  private detectDeviceType() {
    let isMobile = () => {
      return Boolean(navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i));
    };

    let isTablet = () => {
      return (navigator.userAgent.match(/iPad/i) || (navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/Mobile/i)));
    };

    let hasTouch = () => {
      return ("maxTouchPoints" in navigator) ? (navigator as any).maxTouchPoints > 0 : ("msMaxTouchPoints" in navigator) ? (navigator as any).msMaxTouchPoints > 0 : false;
    };

    let deviceType = () => {
      if (isMobile() && hasTouch()) {
        return "mobile";
      } else if (isTablet() && hasTouch()) {
        return "tablet";
      } else {
        return "desktop";
      }
    };

    let initialDeviceType = deviceType();
    let deviceType$ = fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        map(deviceType),
        distinctUntilChanged(),
        startWith(initialDeviceType)
      );

    deviceType$.subscribe(deviceType => {
      this.deviceTypeSubject.next(deviceType);
    });
  }

  private detectOrientation() {
    let mediaQuery = window.matchMedia("(orientation: landscape)");
    let initialOrientation = mediaQuery.matches ? "landscape" : "portrait";
    let orientation$ = fromEventPattern<() => void>(
      (handler) => {
        mediaQuery.addListener(handler);
      },
      (handler) => {
        mediaQuery.removeListener(handler);
      }
    ).pipe(
      map(() => mediaQuery.matches ? "landscape" : "portrait"),
      distinctUntilChanged(),
      startWith(initialOrientation)
    );

    orientation$.subscribe(orientation => {
      this.orientationSubject.next(orientation);
    });
  }
}
